/*
FILTER (MIXITUP)
*/

import mixitup from 'mixitup';
import mixitupMultifilter from '../../../../../../../GesagtGetan.Theme/Resources/Private/Fusion/Component/MixItUp/multifilter.js';

mixitup.use(mixitupMultifilter);

const mixitupContainer = document.querySelector('.seminar-category .product-list__products');

if (mixitupContainer) {
    let mixer = mixitup(mixitupContainer, {
        selectors: {
            target: '.product-list__product',
        },
        multifilter: {
            enable: true,
        },
    });
}

/*
CHANGE LABEL ON FILTER
*/

const buttonsToChangeLabel = document.querySelectorAll(
    '.seminar-filters__choices [data-toggle], .seminar-filters__choices [data-filter]',
);
const multipleChosenLabel = 'Mehrere ausgewählt';

[...buttonsToChangeLabel].forEach((btn) => {
    btn.addEventListener('click', () => {
        const thisToggleValue = btn.getAttribute('data-toggle');
        const isBeingDeactivated = btn.classList.contains('mixitup-control-active');
        const allChosenChoices = btn
            .closest('.seminar-filters__choices')
            .querySelectorAll(".mixitup-control-active:not([data-toggle='" + thisToggleValue + "'])");
        const multipleChosen = allChosenChoices.length;
        const labelWrapper = btn.closest('.seminar-filters__dropdown').querySelector('.seminar-filters__dropdown-box');
        const labelEl = labelWrapper.querySelector('.seminar-filters__search, span');
        let label = btn.getAttribute('data-label');
        if (!label) {
            label = btn.querySelector('span').innerHTML;
        }

        if (btn.getAttribute('data-filter')) {
            labelEl.innerHTML = label;
            labelEl.setAttribute('placeholder', label);
        } else {
            if (isBeingDeactivated) {
                if (multipleChosen) {
                    if (allChosenChoices.length == 1) {
                        label = allChosenChoices[0].getAttribute('data-label');
                        if (!label) {
                            label = allChosenChoices[0].querySelector('span').innerHTML;
                        }
                    } else {
                        label = multipleChosenLabel;
                    }

                    labelEl.innerHTML = label;
                    labelEl.setAttribute('placeholder', label);
                } else {
                    labelEl.innerHTML = labelWrapper.getAttribute('data-label');
                    labelEl.setAttribute('placeholder', labelWrapper.getAttribute('data-label'));
                }
            } else {
                if (multipleChosen) {
                    label = multipleChosenLabel;
                }
                labelEl.innerHTML = label;
                labelEl.setAttribute('placeholder', label);
            }
        }
        labelEl.style.opacity = '1';
    });
});

/*
DROPDOWNS
*/

const dropdowns = document.querySelectorAll('.seminar-filters__dropdown');

[...dropdowns].forEach((dropdown) => {
    const trigger = dropdown.querySelector('.seminar-filters__dropdown-box');

    dropdown.addEventListener('click', (evt) => {
        evt.stopPropagation();
    });

    trigger.addEventListener('click', () => {
        if (dropdown.classList.contains('open')) {
            dropdown.classList.remove('open');
        } else {
            closeAllDropdowns();
            dropdown.classList.add('open');
        }
    });
});

document.addEventListener('click', () => {
    closeAllDropdowns();
});

document.onkeydown = function (evt) {
    evt = evt || window.event;
    if (evt.key == 'Escape') {
        closeAllDropdowns();
    }
};

function closeAllDropdowns() {
    [...dropdowns].forEach((dropdown) => {
        dropdown.classList.remove('open');
    });
}

/*
CALENDAR
*/

const calendarCloseButton = document.querySelector('.seminar-filters__calendar-ok');
if (calendarCloseButton) {
    calendarCloseButton.addEventListener('click', () => {
        closeAllDropdowns();
    });
}

const calendarArrowButtons = document.querySelectorAll('.seminar-filters__calendar-arrow');
[...calendarArrowButtons].forEach((calendarArrowButton) => {
    calendarArrowButton.addEventListener('click', () => {
        if (calendarArrowButton.classList.contains('seminar-filters__calendar-arrow--next')) {
            changeCalendarPage();
        } else {
            changeCalendarPage(true);
        }
    });
});

function changeCalendarPage(previous) {
    const currentPage = document.querySelector('.seminar-filters__calendar-page.show');

    let pageToShow = null;
    if (previous) {
        pageToShow = currentPage.previousSibling;
    } else {
        pageToShow = currentPage.nextSibling;
    }

    if (pageToShow) {
        pageToShow.classList.add('show');
        currentPage.classList.remove('show');
    }
}

/*
    STATE FILTERS
*/

const countryFilterButtons = document.querySelectorAll('.seminar-filters__checkbox[data-filter*="data-country"]');
const stateFilterWrappers = document.querySelectorAll('.seminar-filters__filter[data-states-of]');

[...countryFilterButtons].forEach((countryFilterButton) => {
    countryFilterButton.addEventListener('click', () => {
        const country = countryFilterButton.getAttribute('data-label');
        [...stateFilterWrappers].forEach((stateFilterWrapper) => {
            if (stateFilterWrapper.getAttribute('data-states-of') == country) {
                stateFilterWrapper.classList.add('show');
            } else {
                stateFilterWrapper.classList.remove('show');

                const filtersToDeactivate = stateFilterWrapper.querySelectorAll('.mixitup-control-active');
                [...filtersToDeactivate].forEach((filterToDeactivate) => {
                    filterToDeactivate.click();
                });
            }
        });
    });
});
